import { useConfigurationStore } from '@/Store/storeConfiguration';
import { Intersection } from 'three/src/core/Raycaster';
import { $ } from '@/Engine/state';
import { backWallMinDistance } from '@/Constants/common';

let isDragging = false;
let oldWidth: number;
let draggingElement:Intersection;
export const onPointerMoveRoomDimensions = (intersections: Array<Intersection>, pointer: Array<Intersection>) => {
    if (isDragging && pointer.length>0) {
        const pointerPos=pointer[0].point;
        let newSize = 0;
        //pos1 - точка кубика, pos2 - точка пересечения курсора с потолком
        let pos1=0;
        let pos2 = 0;
        const dragElemOldPos = draggingElement.object.position;
        let sideName = '';
        const MIN_ROOM_SIZE = 0.45;
        switch (draggingElement.object.userData.side) {
            case 'backRight': {
                sideName = 'rightWallWidth';
                oldWidth = useConfigurationStore().getRoomParamByName(sideName);
                pos1=dragElemOldPos.z;
                pos2=pointerPos.z;
                newSize = oldWidth + pos2 - pos1;
                if (newSize < MIN_ROOM_SIZE) { return; }
                draggingElement.object.position.set(dragElemOldPos.x, dragElemOldPos.y, pos2);
                break;
            }
            case 'backLeft': {
                sideName = 'leftWallWidth';
                oldWidth = useConfigurationStore().getRoomParamByName(sideName);
                pos1=dragElemOldPos.z;
                pos2=pointerPos.z;
                newSize = oldWidth + pos2 - pos1;
                if (newSize < MIN_ROOM_SIZE) { return; }
                draggingElement.object.position.set(dragElemOldPos.x, dragElemOldPos.y, pos2);
                break;
            }
            case 'frontRight': {
                sideName = 'frontWallWidth';
                oldWidth = useConfigurationStore().getRoomParamByName(sideName);
                pos1=dragElemOldPos.x;
                pos2=pointerPos.x;
                newSize = oldWidth + pos2 - pos1;
                if (newSize < MIN_ROOM_SIZE) { return; }
                draggingElement.object.position.set(pos2, dragElemOldPos.y, dragElemOldPos.z);
                break;
            }
            case 'backLeftWall': {
                sideName = 'backWallWidth';
                oldWidth = useConfigurationStore().getRoomParamByName(sideName);
                pos1=dragElemOldPos.x;
                pos2=pointerPos.x;
                newSize = oldWidth + pos2 - pos1;
                if (newSize < MIN_ROOM_SIZE) { return; }
                draggingElement.object.position.set(pos2, dragElemOldPos.y, dragElemOldPos.z);
                break;
            }
            case 'backRightWall': {
                sideName = 'backWallWidth';
                oldWidth = useConfigurationStore().getRoomParamByName(sideName);
                pos1=dragElemOldPos.x;
                pos2=pointerPos.x;
                newSize = oldWidth + pos2 - pos1;
                if (newSize < MIN_ROOM_SIZE) { return; }
                draggingElement.object.position.set(pos2, dragElemOldPos.y, dragElemOldPos.z);
                break;
            }
            default: {
                return;
            }
        }

        useConfigurationStore().setRoomParamByName(sideName, newSize);
        // useConfigurationStore().setRoomParamByName(sideName, newSize);
        if ([ 'frontWallWidth' ].includes(sideName)) {
            if (newSize < $.room.backWallWidth ||
                Math.abs($.room.frontWallWidth - $.room.backWallWidth) < backWallMinDistance)
                useConfigurationStore().setRoomParamByName('backWallWidth', newSize);
        }
        if ([ 'backWallWidth' ].includes(sideName)) {
            if (newSize > $.room.frontWallWidth ||
                Math.abs($.room.frontWallWidth - newSize) < backWallMinDistance) {
                isDragging = false;
                useConfigurationStore().setRoomParamByName('backWallWidth', $.room.frontWallWidth);

            }
        }
    }

};

export const onPointerDownRoomDimensions = (intersections: Array<Intersection>, pointer: Array<Intersection>) => {
    if (intersections.length > 0) isDragging = true;
    if(intersections.length>0) draggingElement=intersections[0];
};

export const onPointerUpRoomDimensions = (intersections: Array<Intersection>, pointer: Array<Intersection>) => {
    isDragging = false;
};
